import * as XLSX from 'xlsx';
import { download } from './inventoryExcel';

export interface SheetSpec {
  /** Nombre de la hoja (Excel lo limita a 31 caracteres). */
  name: string;
  /** Encabezado del informe: filtros, período y quién lo generó. */
  header: string[][];
  columns: string[];
  rows: (string | number)[][];
  /** Fila de totales, al final de la hoja. */
  totals?: (string | number)[];
}

/** Arma el libro de Excel de un informe: encabezado con los filtros, la tabla y los totales. */
export function buildReportWorkbook(sheets: SheetSpec[]): Uint8Array {
  const wb = XLSX.utils.book_new();
  for (const s of sheets) {
    const aoa: (string | number)[][] = [...s.header, [], s.columns, ...s.rows];
    if (s.totals) aoa.push([], s.totals);
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws['!cols'] = s.columns.map((c) => ({ wch: Math.min(40, Math.max(12, c.length + 4)) }));
    XLSX.utils.book_append_sheet(wb, ws, s.name.slice(0, 31));
  }
  return new Uint8Array(XLSX.write(wb, { type: 'array', bookType: 'xlsx' }) as ArrayBuffer);
}

export function downloadReport(sheets: SheetSpec[], filename: string) {
  download(buildReportWorkbook(sheets), filename);
}

/**
 * PDF: se usa la impresión del navegador ("Guardar como PDF"), con una hoja de estilos que deja solo el informe.
 * Así no se agrega ninguna dependencia y el archivo sale con las fuentes y los números tal como se ven en pantalla.
 */
export function printReport() {
  window.print();
}
